'use client';

import { type FC } from 'react';

import { CookieConsentBanner } from './CookieConsentBanner';
import { ThirdPartyScripts } from './ThirdPartyScripts';

/** Client bundle for cookie UI + deferred third-party tags (GTM / GA / HubSpot). */
export const CookieConsentRoot: FC = () => {
  return (
    <>
      <ThirdPartyScripts />
      <CookieConsentBanner />
    </>
  );
};
